// @flow

export function deepClone<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    const arrCopy: any[] = [];
    obj.forEach((item, index) => {
      arrCopy[index] = deepClone(item);
    });
    return (arrCopy: any);
  }

  if (obj instanceof Date) {
    return (new Date(obj.getTime()): any);
  }

  if (obj instanceof Map) {
    const mapCopy = new Map();
    obj.forEach((value, key) => {
      mapCopy.set(key, deepClone(value));
    });
    return (mapCopy: any);
  }

  if (obj instanceof Set) {
    const setCopy = new Set();
    obj.forEach(value => {
      setCopy.add(deepClone(value));
    });
    return (setCopy: any);
  }

  const objCopy: {[key: string]: any} = {};
  Object.keys(obj).forEach(key => {
    objCopy[key] = deepClone((obj: Object)[key]);
  });

  return (objCopy: any);
}
